<div class="fixed z-30 inset-0 bg-bg_primary bg-opacity-45 flex items-center justify-center" (click)="onOverlayClick()">
    <div class="bg-card p-6 rounded shadow-lg relative" (click)="$event.stopPropagation()">
        <button
                (click)="requestClose()"
                class="absolute top-2 right-2 text-gray-50 hover:text-light focus:outline-none"
                aria-label="Close Modal">
            ✕
        </button>
        <ng-template #container></ng-template>
    </div>
</div>